import readMore from "utils/read-more/read-more"

export default function setListeners() {
  return Array.from(document.querySelectorAll("[data-read-more]")).map((el) => readMore(el))
}
